module.exports = __webpack_public_path__ + "img/roulette_out.277e915a.png";